import Line from'../vendors/fc-charts/src/chart/line';export default Line;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/viz/line.js
// module id = null
// module chunks = 